import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isNumber, isDef } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Icon from '../icon';
import Star from './star';
export default {
  name: buildComponentName('Rate'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-rate'
    },
    value: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowHalf: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    character: {
      type: String,
      default: ''
    },
    tabindex: {
      type: String,
      default: '0'
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerValue: 0,
      hoverValue: undefined,
      focused: false,
      cleanValue: null
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    }
  },
  watch: {
    value: function value(nVal) {
      if (isDef(nVal)) {
        this.innerValue = nVal;
      }
    }
  },
  created: function created() {
    var value = this.value;
    this.innerValue = value;
  },
  mounted: function mounted() {
    var autofocus = this.autofocus,
        disabled = this.disabled,
        focus = this.focus;

    if (autofocus && !disabled) {
      focus();
    }
  },
  methods: {
    onBlur: function onBlur() {
      if (this.disabled) {
        return;
      }

      this.focused = false;
      this.$emit('blur');
    },
    onFocus: function onFocus() {
      if (this.disabled) {
        return;
      }

      this.focused = true;
      this.$emit('focus');
    },
    focus: function focus() {
      var rateRef = this.$refs.rateRef;

      if (rateRef) {
        rateRef.focus();
      }
    },
    blur: function blur() {
      var rateRef = this.$refs.rateRef;

      if (rateRef) {
        rateRef.blur();
      }
    },
    onMouseLeave: function onMouseLeave() {
      var disabled = this.disabled;

      if (disabled) {
        return;
      }

      this.hoverValue = undefined;
      this.cleanValue = null;
      this.$emit('hover-change');
    },
    onHover: function onHover(e, _ref2) {
      var value = _ref2.value;
      var cleanValue = this.cleanValue;

      if (cleanValue !== value) {
        this.hoverValue = value;
        this.cleanValue = null;
      }

      this.$emit('hover-change', value);
    },
    onClick: function onClick(e, _ref3) {
      var value = _ref3.value;
      var innerValue = this.innerValue,
          allowClear = this.allowClear,
          onMouseLeave = this.onMouseLeave;
      onMouseLeave();
      var relVal = value;

      if (allowClear) {
        if (value === innerValue) {
          this.cleanValue = innerValue;
          relVal = 0;
        }
      }

      this.innerValue = relVal;
      this.$emit('input', relVal);
      this.$emit('change', relVal);
    },
    renderStars: function renderStars() {
      var h = this.$createElement;
      var $scopedSlots = this.$scopedSlots,
          character = this.character,
          count = this.count,
          innerValue = this.innerValue,
          hoverValue = this.hoverValue,
          allowHalf = this.allowHalf,
          disabled = this.disabled,
          focused = this.focused,
          onHover = this.onHover,
          onClick = this.onClick;

      var characterFn = $scopedSlots.character || character && function () {
        return character;
      } || function () {
        return h(Icon, {
          "attrs": {
            "type": "star"
          }
        });
      };

      var stars = [];
      var on = {
        hover: onHover,
        click: onClick
      };

      for (var i = 0; i < count; i += 1) {
        var props = {
          index: i,
          character: characterFn,
          value: isNumber(hoverValue) ? hoverValue : innerValue,
          allowHalf: allowHalf,
          disabled: disabled,
          focused: focused
        };
        stars.push(h(Star, {
          "props": _objectSpread({}, props),
          "on": _objectSpread({}, on)
        }));
      }

      return stars;
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        disabled = this.disabled,
        tabindex = this.tabindex,
        onMouseLeave = this.onMouseLeave,
        onFocus = this.onFocus,
        onBlur = this.onBlur,
        renderStars = this.renderStars;
    var on = {
      focus: onFocus,
      blur: onBlur,
      mouseleave: onMouseLeave
    };
    var attrs = {
      tabindex: disabled ? -1 : tabindex
    };
    return h("ul", _mergeJSXProps([{}, {
      class: classes,
      attrs: attrs,
      on: on,
      ref: 'rateRef'
    }]), [renderStars()]);
  }
};